/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PromotionModal from "./modalCrossSell";
import {
  MoreVertical,
  Edit,
  Trash2,
  Plus,
  Folder,
  Tag,
  ArrowLeft,
  ArrowRight,
  Truck,
  Percent,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  getFirestore,
  collection,
  addDoc,
  Timestamp,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";

function CrossSell() {
  const [showSideBar, setShowSideBar] = useState(true);
  const [data2, setData2] = useState(["", "", "", "", ""]);
  const [promotionToEdit, setPromotionToEdit] = useState(null);
  const { t, i18n } = useTranslation();

  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const crossSell = useSelector((state) => state.crossSell);

  const [isPromotionModalOpen, setIsPromotionModalOpen] = useState(false);
  const [isLoadingCrossSell, setIsLoadingCrossSell] = useState(false);

  const [crossSellData, setCrossSellData] = useState([]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    !!store.id && setData2(store.categories);
  }, [store]);

  useEffect(() => {
    if (crossSell) {
      if (Array.isArray(crossSell)) {
        setCrossSellData(crossSell);
        setIsLoadingCrossSell(false);
      } else if (crossSell.id) {
        setCrossSellData([crossSell]);
        setIsLoadingCrossSell(false);
      } else if (typeof crossSell === "object" && crossSell.data) {
        if (Array.isArray(crossSell.data)) {
          setCrossSellData(crossSell.data);
        } else if (typeof crossSell.data === "object") {
          const dataArray = Object.keys(crossSell.data).map((key) => ({
            id: key,
            ...crossSell.data[key],
          }));
          setCrossSellData(dataArray);
        }
        setIsLoadingCrossSell(false);
      }
    } else {
      setCrossSellData([]);
      setIsLoadingCrossSell(false);
    }
  }, [crossSell]);

  const getCrossSellLimits = () => {
    const subscription = account?.subscription;
    const plan = subscription?.plan || "الأساسية";

    const isLegendaryActive = plan === "الأسطورية" && subscription?.endDate;
    let isSubscriptionValid = false;

    if (isLegendaryActive && subscription.endDate) {
      try {
        let endDate;
        if (subscription.endDate.seconds !== undefined) {
          endDate = new Date(subscription.endDate.seconds * 1000);
        } else {
          endDate = new Date(subscription.endDate);
        }

        const now = new Date();
        isSubscriptionValid = endDate > now;
      } catch (error) {
        console.error("Error checking subscription date:", error);
        isSubscriptionValid = false;
      }
    }

    switch (plan) {
      case "الأسطورية":
        return {
          max: isSubscriptionValid ? 5 : 1,
          current: crossSellData.length,
          planName: "الأسطورية",
          upgradeTo: isSubscriptionValid ? null : "الأسطورية (نشطة)",
          isActive: isSubscriptionValid,
        };
      case "المتطورة":
        return {
          max: 1,
          current: crossSellData.length,
          planName: "المتطورة",
          upgradeTo: "الأسطورية",
        };
      case "الأساسية":
      default:
        return {
          max: 1,
          current: crossSellData.length,
          planName: "الأساسية",
          upgradeTo: "المتطورة أو الأسطورية",
        };
    }
  };

  const handleEditPromotion = (promotion) => {
    setPromotionToEdit(promotion);
    setIsPromotionModalOpen(true);
  };

  const handleUpdatePromotion = async (promotionData) => {
    try {
      const updateData = {
        title: promotionData.title,
        subtitle: promotionData.subtitle,
        promotionType: promotionData.promotionType,
        triggerProductIds: promotionData.triggerProductIds || [],
        requireAllProducts: promotionData.requireAllProducts || false,
        timeCrossSell: promotionData.timeCrossSell || {
          active: false,
          time: 0,
        },
        updatedAt: Timestamp.now(),
      };

      if (promotionData.promotionType === "discount") {
        updateData.discountType = promotionData.discountType;
        updateData.discountValue = promotionData.discountValue;
        updateData.discountedProductIds =
          promotionData.discountedProductIds || [];
      } else if (promotionData.promotionType === "freeShipping") {
        if (
          promotionData.freeShippingProductIds &&
          promotionData.freeShippingProductIds.length > 0
        ) {
          updateData.freeShippingProductIds =
            promotionData.freeShippingProductIds;
        } else {
          updateData.freeShippingProductIds = [];
        }
      }

      await updateDoc(doc(db, "crossSell", promotionData.id), updateData);

      setCrossSellData((prevData) =>
        prevData.map((item) =>
          item.id === promotionData.id ? { ...item, ...promotionData } : item
        )
      );

      Swal.fire({
        icon: "success",
        title: t("cashBack.swal.updateSuccess.title"),
        text: t("crossSell.swal.updateSuccess.text"),
        timer: 2000,
        showConfirmButton: false,
      });

      setIsPromotionModalOpen(false);
      setPromotionToEdit(null);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la promotion :", error);
      Swal.fire({
        icon: "error",
        title: t("error"),
        text: t("cashBack.swal.error.textUpdate"),
      });
    }
  };

  const handleOpenPromotionModal = () => {
    const limits = getCrossSellLimits();

    if (crossSellData.length >= limits.max) {
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        icon: "warning",
        title: t("ui.limitReached"),
        html: `
          <p>وصلت للحد الأقصى من عروض Cross-Sell في باقتك الحالية (${
            limits.max
          } ${limits.max === 1 ? "عرض" : "عروض"}).</p>
          <p class="mt-2">للحصول على المزيد من العروض، قم بترقية باقتك إلى "${
            limits.upgradeTo
          }".</p>
        `,
        confirmButtonText: t("ship.ok"),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setPromotionToEdit(null);
    setIsPromotionModalOpen(true);
  };

  const handleCreatePromotion = async (promotionData) => {
    const limits = getCrossSellLimits();

    if (crossSellData.length >= limits.max) {
      Swal.fire({
        icon: "warning",
        title: t("ui.limitReached"),
        text: t("ui.planItemLimit", { value0: (limits.max), value1: (limits.max === 1 ? "عرض" : "عروض") }),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    const dataWithUser = {
      ...promotionData,
      timeCrossSell: promotionData.timeCrossSell || { active: false, time: 0 },
      user: account.user,
      createdAt: Timestamp.now(),
    };

    try {
      const docRef = await addDoc(collection(db, "crossSell"), dataWithUser);

      Swal.fire({
        icon: "success",
        title: t("cashBack.swal.createSuccess.title"),
        text: t("crossSell.swal.createSuccess.text"),
        timer: 2000,
        showConfirmButton: false,
      });

      setIsPromotionModalOpen(false);
      setPromotionToEdit(null);
    } catch (error) {
      console.error("Erreur lors de la création de la promotion :", error);
      Swal.fire({
        icon: "error",
        title: t("error"),
        text: t("cashBack.swal.error.textCreate"),
      });
    }
  };

  const handleDeletePromotion = async (promotionId) => {
    const MySwal = withReactContent(Swal);

    const result = await MySwal.fire({
      title: t("cashBack.swal.deleteConfirm.title"),
      text: t("cashBack.swal.deleteConfirm.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("cashBack.swal.deleteConfirm.confirm"),
      cancelButtonText: t("annule"),
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await deleteDoc(doc(db, "crossSell", promotionId));

        setCrossSellData((prevData) =>
          prevData.filter((item) => item.id !== promotionId)
        );

        MySwal.fire({
          icon: "success",
          title: t("ship.delete_success"),
          text: t("cashBack.swal.deleteSuccess.text"),
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error deleting promotion:", error);
        MySwal.fire({
          icon: "error",
          title: t("error"),
          text: t("cashBack.swal.error.textDelete"),
        });
      }
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "غير محدد";

    let date;
    try {
      if (timestamp.seconds !== undefined) {
        date = new Date(timestamp.seconds * 1000);
      } else {
        date = new Date(timestamp);
      }

      return date.toLocaleDateString("ar-AR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return "غير محدد";
    }
  };

  const getProductName = (productId) => {
    if (!products || !Array.isArray(products))
      return `منتج ${productId?.substring(0, 6) || ""}...`;

    const product = products.find((p) => p.id === productId);
    return product?.name || `منتج ${productId?.substring(0, 6) || ""}...`;
  };

  const renderProductList = (productIds, maxItems = 3) => {
    if (!productIds || productIds.length === 0) {
      return (
        <div className="!text-xs !text-gray-500 dark:!text-gray-500">
          {t("crossSell.states.noPromotions.emptyProduct")}
        </div>
      );
    }

    const displayedProducts = productIds.slice(0, maxItems);
    const remainingCount = productIds.length - maxItems;

    return (
      <>
        {displayedProducts.map((id, index) => (
          <div
            key={index}
            className="!text-xs !text-gray-700 dark:!text-gray-300"
          >
            • {getProductName(id)}
          </div>
        ))}
        {remainingCount > 0 && (
          <div className="!text-xs !text-gray-500 dark:!text-gray-500">
            + {remainingCount} {t("ui.anotherProduct")}
          </div>
        )}
      </>
    );
  };

  const getPromotionIcon = (promotionType) => {
    if (promotionType === "freeShipping") {
      return <Truck size={14} className="mr-1" />;
    }
    return <Tag size={14} className="mr-1" />;
  };

  const getPromotionColor = (promotionType) => {
    if (promotionType === "freeShipping") {
      return {
        bg: "!bg-green-100 !text-green-700 dark:!bg-green-900/30 dark:!text-green-300",
        main: "text-green-600 dark:text-green-400",
        button:
          "!bg-green-100 !text-green-700 !hover:bg-green-200 dark:!bg-green-900/30 dark:!text-green-300 dark:!hover:bg-green-900/50",
      };
    }
    return {
      bg: "!bg-purple-100 !text-purple-700 dark:!bg-purple-900/30 dark:!text-purple-300",
      main: "text-purple-600 dark:text-purple-400",
      button:
        "!bg-purple-100 !text-purple-700 !hover:bg-purple-200 dark:!bg-purple-900/30 dark:!text-purple-300 dark:!hover:bg-purple-900/50",
    };
  };

  const renderPromotionValue = (promotion) => {
    if (promotion.promotionType === "freeShipping") {
      return (
        <span className="!text-lg !font-bold text-green-600 dark:text-green-400">
          {t("landing.suggestion_free_delivery")}
        </span>
      );
    } else {
      return (
        <span className="!text-lg !font-bold text-purple-700 dark:text-purple-300">
          {promotion.discountValue}
          {promotion.discountType === "percentage" ? "%" : t("ui.dzd")}
        </span>
      );
    }
  };

  const getTargetProducts = (promotion) => {
    return promotion.discountedProductIds || [];
  };

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={i18n.dir()}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          <div className="bg-white rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1 dark:text-[#c88ef2]">
                  {t("crossSell.page.title")}
                </h2>
                <p className="text-gray-600 mb-0 dark:text-gray-400">
                  {t("crossSell.page.description")}
                </p>
              </div>
              <button
                onClick={handleOpenPromotionModal}
                className="px-4 py-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium rounded-lg inline-flex items-center transition-colors gap-2 dark:bg-[#814a9f] dark:hover:bg-[#9b59bf]"
              >
                <Plus size={18} />
                {t("crossSell.buttons.createCrossSell")}
              </button>
            </div>
          </div>

          <div className="p-4">
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-xl font-bold text-[#9e68ba] mb-1 dark:text-[#c88ef2]">
                    {t("crossSell.page.promoSectionTitle")}
                  </h3>
                  <p className="text-gray-600 mb-0 dark:text-gray-400">
                    {t("crossSell.page.promoSectionDescription")}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  {crossSellData.length > 0 && (
                    <div className="bg-[#fcf6ff] px-3 py-1 rounded-lg dark:bg-[#2a2a2c]">
                      <span className="text-sm text-[#9e68ba] font-medium dark:text-[#c88ef2]">
                        {crossSellData.length} / {getCrossSellLimits().max}{" "}
                        {t("crossSell.page.discountCountText")}
                      </span>
                    </div>
                  )}
                  <div
                    className={`px-3 py-1 rounded-lg ${
                      getCrossSellLimits().max === 5 &&
                      getCrossSellLimits().isActive
                        ? "bg-yellow-100 dark:bg-yellow-900/20"
                        : "bg-gray-100 dark:bg-gray-800"
                    }`}
                  >
                    <span
                      className={`text-xs font-medium ${
                        getCrossSellLimits().max === 5 &&
                        getCrossSellLimits().isActive
                          ? "text-yellow-700 dark:text-yellow-300"
                          : "text-gray-600 dark:text-gray-400"
                      }`}
                    >
                      {t("ui.planLabel")} {getCrossSellLimits().planName}
                      {getCrossSellLimits().max === 5 &&
                        getCrossSellLimits().isActive &&
                        " ⭐"}
                    </span>
                  </div>
                </div>
              </div>

              {isLoadingCrossSell ? (
                <div className="flex justify-center items-center min-h-[200px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#9e68ba]"></div>
                </div>
              ) : crossSellData.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {crossSellData.map((promotion) => {
                    if (!promotion || !promotion.id) return null;

                    const triggerProducts = promotion.triggerProductIds || [];
                    const targetProducts = getTargetProducts(promotion);
                    const colors = getPromotionColor(promotion.promotionType);
                    const requireAll = promotion.requireAllProducts || false;

                    return (
                      <div
                        key={promotion.id}
                        className="!border !border-gray-200 !rounded-lg !p-4 !hover:shadow-md !transition-shadow !bg-white !text-gray-900 dark:!bg-[#1e1e1f] dark:!text-gray-100 dark:!border-[#3c3a3d]"
                      >
                        <div className="!flex !justify-between !items-start !mb-3">
                          <div className="!flex-1">
                            <div className="!flex !items-center !gap-2 !mb-1">
                              {getPromotionIcon(promotion.promotionType)}
                              <h4 className="!font-bold !text-gray-900 !text-lg dark:!text-white">
                                {promotion.title || t("cashBack.fallback.noTitle")}
                              </h4>
                            </div>
                            <p className="!text-gray-600 !text-sm !mt-1 dark:!text-gray-400">
                              {promotion.subtitle || t("cashBack.fallback.noSubtitle")}
                            </p>
                          </div>

                          <span
                            className={`!px-2 !py-1 !text-xs !rounded-full !font-medium !ml-2 !flex-shrink-0 ${colors.bg}`}
                          >
                            {promotion.promotionType === "freeShipping"
                              ? t("landing.suggestion_free_delivery")
                              : promotion.discountType === "percentage"
                              ? t("crossSell.labels.percentage")
                              : t("crossSell.labels.fixedAmount")}
                          </span>
                        </div>

                        <div className="!flex !items-center !justify-between !my-4 !px-2">
                          <div className="!text-center !flex-1">
                            <div className="!px-3 !py-1 !rounded-lg !text-xs !font-medium !bg-blue-100 !text-blue-700 dark:!bg-blue-900/40 dark:!text-blue-300">
                              {t("crossSell.labels.onPurchase")}
                            </div>
                            <div className="!mt-2 !space-y-1">
                              {renderProductList(triggerProducts)}
                            </div>
                          </div>

                          <div className="!mx-2 !flex-shrink-0">
                            {i18n.dir() === "rtl" ? (
                              <ArrowLeft className={colors.main} size={20} />
                            ) : (
                              <ArrowRight className={colors.main} size={20} />
                            )}
                          </div>

                          <div className="!text-center !flex-1">
                            <div
                              className={`!px-3 !py-1 !rounded-lg !text-xs !font-medium ${colors.bg}`}
                            >
                              {promotion.promotionType === "freeShipping"
                                ? t("ui.benefitsFrom")
                                : t("crossSell.labels.onDiscount")}
                            </div>
                            <div className="!mt-2 !space-y-1">
                              {renderProductList(targetProducts)}
                            </div>
                          </div>
                        </div>

                        <div className="!mt-4 !pt-3 !border-t !border-gray-100 dark:!border-[#3c3a3d]">
                          <div className="!flex !items-center !justify-between">
                            <div>
                              <span className="!text-sm !text-gray-600 dark:!text-gray-400">
                                {promotion.promotionType === "freeShipping"
                                  ? t("orderDetails.product_details.offer")
                                  : t("crossSell.page.discountValueLabel")}
                              </span>
                              <span className="!mr-2">
                                {renderPromotionValue(promotion)}
                              </span>
                            </div>
                            <div className="!text-xs !text-gray-500 dark:!text-gray-500">
                              {formatDate(promotion.createdAt)}
                            </div>
                          </div>

                          {requireAll && (
                            <div className="!mt-2 !pt-2 !border-t !border-gray-100 dark:!border-[#3c3a3d]">
                              <div className="!flex !items-center !gap-1">
                                <span className="!text-xs !text-yellow-600 dark:!text-yellow-400">
                                  ⚠️
                                </span>
                                <span className="!text-xs !text-gray-600 dark:!text-gray-400">
                                  {t("cashBack.labels.requireAll")}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="!mt-4 !flex !gap-2 !pt-3 !border-t !border-gray-100 dark:!border-[#3c3a3d]">
                          <button
                            onClick={() => handleEditPromotion(promotion)}
                            className={`!flex-1 !px-3 !py-2 !text-sm !font-medium !rounded-lg !transition-colors ${colors.button} !flex !items-center !justify-center !gap-1`}
                          >
                            <Edit size={14} />
                            {t("crossSell.buttons.edit")}
                          </button>

                          <button
                            onClick={() => handleDeletePromotion(promotion.id)}
                            className="!flex-1 !px-3 !py-2 !text-sm !font-medium !rounded-lg !transition-colors !bg-red-100 !text-red-700 !hover:bg-red-200 dark:!bg-red-900/20 dark:!text-red-400 dark:!hover:bg-red-900/40 !flex !items-center !justify-center !gap-1"
                          >
                            <Trash2 size={14} />
                            {t("crossSell.buttons.delete")}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-12">
                  <div className="mx-auto w-16 h-16 bg-gray-100 dark:bg-[#2a2a2c] rounded-full flex items-center justify-center mb-4">
                    <Tag
                      className="text-gray-400 dark:text-gray-500"
                      size={24}
                    />
                  </div>
                  <h4 className="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t("crossSell.states.noPromotions.title")}
                  </h4>
                  <p className="text-gray-500 dark:text-gray-400 mb-6">
                    {t("crossSell.states.noPromotions.subtitle")}
                  </p>
                  <button
                    onClick={handleOpenPromotionModal}
                    className="px-4 py-2 bg-[#9e68ba] text-white rounded-lg hover:bg-[#8a5ca5] dark:bg-[#c88ef2] dark:text-[#1a1a1a] dark:hover:bg-[#b67de0] transition-colors inline-flex items-center gap-2"
                  >
                    <Tag size={16} />
                    {t("crossSell.states.noPromotions.action")}
                  </button>
                </div>
              )}
            </div>
          </div>

          <Footer />
        </div>
      </div>

      <PromotionModal
        isOpen={isPromotionModalOpen}
        onClose={() => {
          setIsPromotionModalOpen(false);
          setPromotionToEdit(null);
        }}
        products={products || []}
        promotionToEdit={promotionToEdit}
        onCreatePromotion={handleCreatePromotion}
        onUpdatePromotion={handleUpdatePromotion}
      />

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .image-hover-overlay::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 0;
          background: rgba(255, 255, 255, 0.5);
          transition: height 0.3s ease;
          z-index: 10;
        }

        .group:hover .image-hover-overlay::after {
          height: 100%;
        }

        .overlay-content {
          position: absolute;
          inset: 0;
          z-index: 20;
          opacity: 0;
          transition: opacity 0.3s ease 0.15s;
        }

        .group:hover .overlay-content {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}

export default CrossSell;
